import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["suggestion", "address"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { mapSEOandGovernmentLocalities } from '../utils/seoLocalities';
import generator from './generator';
var hcdActions = {
  getActions: function getActions() {
    var isDemo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var actions = generator({
      resource: 'hcd',
      scope: isDemo ? 'pat' : 'pat-public'
    });

    actions.search = function (filters) {
      var selectedSuggestion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var selectedAddress = arguments.length > 2 ? arguments[2] : undefined;
      var options = arguments.length > 3 ? arguments[3] : undefined;
      var objectType = selectedSuggestion.objectType;

      var mergedFilter = _objectSpread(_objectSpread({
        limit: 10
      }, filters), {}, _defineProperty({}, "".concat(objectType, ".shortName"), selectedSuggestion.shortName));

      var isReplace = options === null || options === void 0 ? void 0 : options.isReplace;

      var _ref = selectedAddress || {},
          type = _ref.type,
          longitude = _ref.longitude,
          latitude = _ref.latitude,
          zipCode = _ref.zipCode,
          shortName = _ref.shortName;

      if (['street', 'housenumber'].includes(type)) {
        mergedFilter.longitude = longitude;
        mergedFilter.latitude = latitude;
      } else if (zipCode && shortName) {
        var _mapSEOandGovernmentL3 = mapSEOandGovernmentLocalities("".concat(zipCode, "-").concat(shortName)),
            _mapSEOandGovernmentL4 = _slicedToArray(_mapSEOandGovernmentL3, 2),
            apiGouvLocality = _mapSEOandGovernmentL4[1];

        mergedFilter.locality = apiGouvLocality;
      }

      var suggestion = mergedFilter.suggestion,
          address = mergedFilter.address,
          rest = _objectWithoutProperties(mergedFilter, _excluded);

      return actions.getList(rest, isReplace);
    };

    return actions;
  }
};
export default hcdActions;
//# sourceMappingURL=hcd.js.map